document.addEventListener('cart:updated', () => {
  updatePreorderDate();
});

document.addEventListener('DOMContentLoaded', () => {
  updatePreorderDate();
});

function updatePreorderDate() {
  const preorderMessageEl = document.querySelector('[data_order_date]');
  const preorderInputEl = document.querySelector('.cart-attribute-date');

  if (!preorderMessageEl || !preorderInputEl) return;

  const preorderISO = preorderInputEl.dataset.preorderIso;
  const dateToday = new Date().toISOString().split('T')[0];

  if (preorderISO && preorderISO > dateToday) {
    // Update message
    const dateObj = new Date(preorderISO);
    const readable = dateObj.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long'
    });

    preorderMessageEl.textContent = `Order to be dispatched by ${readable}`;
    preorderInputEl.value = preorderISO;
  } else {
    preorderMessageEl.textContent = '';
    preorderInputEl.value = '';
  }
}
